import type { Member } from '../types';
import { signOut } from '../lib/session';
import { LOCALE_META } from '../lib/locales';

export default function Pending({ member }: { member: Member }) {
  const blocked = member.status === 'blocked';
  return (
    <div className="gate">
      <div className="mark">{blocked ? 'No access' : 'Waiting on approval'}</div>
      <p className="lede">
        {blocked ? (
          <>Your access to the translation tool has been removed. Your past work stays credited to you.</>
        ) : (
          <>
            Thanks {member.display_name.split(' ')[0]} — Sam has been asked to let you in
            for {member.languages.map((l) => LOCALE_META[l]?.native ?? l).join(' and ')}. Until then
            there is nothing here to see. Refresh once he has approved you.
          </>
        )}
      </p>
      <div style={{ display: 'flex', gap: 8 }}>
        {!blocked && (
          <button className="btn pri" onClick={() => window.location.reload()}>Check again</button>
        )}
        <button className="btn" onClick={() => void signOut()}>Sign out</button>
      </div>
    </div>
  );
}
